import React, { useState } from "react";
import { Offcanvas, CloseButton, Form, InputGroup } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import TooltipX from 'react-bootstrap/Tooltip';
import { getFirestore, collection, getDocs } from 'firebase/firestore';
import { spinner } from "../utils/Helper";
import { toast } from 'react-toastify';
import AdminCheckReportz from "../utils/adminCheckReportz";

export default function XAdminReports(props) {
    const [profiles, setProfiles] = useState([]);
    const [levels, setLevels] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    const handleCloseCanvas = () => {
        if (props.onToggle) props.onToggle();
        setSearchTerm("");
    };

      const refreshReport = (res) => {
        getAdminData()
        setSearchTerm("");
    };

    const getAdminData = async () => {
        const db = getFirestore();
        spinner(true);
        try {
            const profileSnap = await getDocs(collection(db, "profiles"));
            const profileData = profileSnap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            const levelsSnap = await getDocs(collection(db, "membership_levels"));
            const levelsData = levelsSnap.docs.map(doc => ({ ...doc.data(), id: doc.id }));
            setProfiles(profileData);
            setLevels(levelsData);
            spinner(false);
            if (props.onToggle) props.onToggle();
        } catch (err) {
            spinner(false);
            toast.error(err.message);
        }
    };

    const filteredProfiles = profiles.filter(user =>
        (user.name || user.displayName || "").toLowerCase().includes(searchTerm.toLowerCase())
    );

    return (
        <>
            
                <Button variant="primary" onClick={getAdminData} className="hoverX">
                    <span className="circle-btn centerCircle">🧩</span> Membership
                </Button>
           

            <Offcanvas show={props.isOpen} onHide={handleCloseCanvas} backdropClassName="adminBackdrop" className="bg-dark bordery" placement="end" >
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        <h3 className="xTitle modified animated rollIn">Details</h3>
                    </Offcanvas.Title>
                    <CloseButton variant="white" onClick={handleCloseCanvas} />
                </Offcanvas.Header>
                <Offcanvas.Body className="bg-dark bordery">
                    <InputGroup className="mb-3">
                        <Form.Control
                            type="search"
                            placeholder="🔎 Search Names..."
                            className="glass-search mb-3 form-control"
                            onChange={(e) => setSearchTerm(e.target.value)}
                            value={searchTerm}
                        />
                    </InputGroup>

                    <AdminCheckReportz
                        profiles={filteredProfiles}
                        levels={levels}
                        onSendToParent={refreshReport}
                    />
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
}